import { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Globe, Mail, Play } from 'lucide-react';
import '../styles/sections.css';
import './About.css';

function AboutVideo() {
  const videoRef = useRef(null);
  const [ended, setEnded] = useState(false);

  const handleEnded = () => {
    setEnded(true);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setEnded(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="aboutVideo"
    >
      <video
        ref={videoRef}
        src="/videos/gregory-kennedy.mp4"
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={handleEnded}
        aria-label="Gregory Kennedy — Senior ML/AI Engineer"
      />
      {ended && (
        <button
          className="aboutReplayButton"
          onClick={handleReplay}
          aria-label="Replay Gregory Kennedy video"
        >
          <Play size={16} />
          Replay
        </button>
      )}
    </motion.div>
  );
}

export default function About() {
  return (
    <section className="section aboutSection">
      <div className="container">
        <AboutVideo />

        <div className="aboutCopy">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="sectionLabel"
          >
            About the Founder
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="sectionTitle"
          >
            Built by Gregory Kennedy — Senior ML/AI Engineer
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="sectionSubtitle"
          >
            Gregory Kennedy architects deterministic AI systems for regulated
            knowledge work. After years evaluating frameworks, models, and agent
            runtimes in production, he adapted the Stripe Minions blueprint pattern
            into Keraunos — a system where code-enforced gates, not model size,
            determine whether output ships.
          </motion.p>

          <div className="aboutSpacer" aria-hidden="true" />

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="sectionSubtitle"
          >
            He also leads the <strong>Keraunos SEGP</strong> project:
            a 7-phase Skill Evaluation & Governance Platform that makes AI agent
            skills safe, measurable, and production-ready.
          </motion.p>

          <div className="socials">
            <a href="https://www.linkedin.com/in/gregorykennedymindfuldude/" target="_blank" rel="noreferrer" className="social" aria-label="LinkedIn">
              <Globe size={18} />
            </a>
            <a href="mailto:peacedude@gmail.com" target="_blank" rel="noreferrer" className="social" aria-label="Email">
              <Mail size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
